import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import TranslateIcon from "@mui/icons-material/Translate";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppTheme } from "@/context/ThemeContext";
import { LANGUAGES } from "@/i18n";

function ThemeLanguageControls({ compact = false }) {
  const { mode, toggleTheme } = useAppTheme();
  const { t, i18n } = useTranslation();
  const [anchor, setAnchor] = useState(null);
  const current =
    LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Tooltip
        title={mode === "dark" ? t("common.lightMode") : t("common.darkMode")}
      >
        <IconButton
          data-testid="theme-toggle"
          onClick={toggleTheme}
          size="small"
          color="inherit"
          aria-label={t("common.toggleTheme")}
        >
          {mode === "dark" ? (
            <LightModeIcon fontSize="small" />
          ) : (
            <DarkModeIcon fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
      <Tooltip title={t("common.language")}>
        <Button
          data-testid="language-switcher"
          size="small"
          color="inherit"
          onClick={(e) => setAnchor(e.currentTarget)}
          startIcon={<TranslateIcon fontSize="small" />}
          sx={{
            minWidth: 0,
            px: compact ? 1 : 1.25,
            fontWeight: 600,
            color: "text.secondary",
          }}
        >
          {compact ? current.code.toUpperCase() : current.native}
        </Button>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {LANGUAGES.map((l) => (
          <MenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            selected={l.code === i18n.language}
            onClick={() => {
              i18n.changeLanguage(l.code);
              setAnchor(null);
            }}
          >
            <ListItemText primary={l.native} secondary={l.label} />
          </MenuItem>
        ))}
      </Menu>
    </Stack>
  );
}

export default ThemeLanguageControls;
